import './Privacy.css';

export default function Privacy() {
  return (
    <section className="privacy" id="privacy">
      <div className="privacy-inner">
        <div className="privacy-icon reveal">🔒</div>
        <p className="privacy-quote reveal">
          Your documents never leave your device.
        </p>
        <div className="privacy-three reveal">
          <span>No account</span>
          <span>No upload</span>
          <span>No exceptions</span>
        </div>
        <p className="privacy-note reveal">
          This is not a privacy policy. It is the architecture.<br />
          TAGpdf has no server to send your files to.
        </p>
      </div>
    </section>
  );
}
